if (process.env.BUILD_GC === 'reading' || process.env.BUILD_GC === 'cicp') {
  module.exports = require('./reading')
} else {
  module.exports = null
}
